import { ACTION_TYPES } from '../context/wineAppReducer';

// Navigation Actions
export const setCurrentStep = (step) => ({
    type: ACTION_TYPES.SET_CURRENT_STEP,
    payload: step
});

export const nextStep = () => ({
    type: ACTION_TYPES.NEXT_STEP
});

export const previousStep = () => ({
    type: ACTION_TYPES.PREVIOUS_STEP
});

export const resetApp = () => ({
    type: ACTION_TYPES.RESET_APP
});

// Dining Location Actions
export const setDiningLocation = (location) => ({
    type: ACTION_TYPES.SET_DINING_LOCATION,
    payload: location
});

// Restaurant Actions
export const setRestaurant = (restaurant) => ({
    type: ACTION_TYPES.SET_RESTAURANT,
    payload: restaurant
});

export const setAllRestaurants = (restaurants) => ({
    type: ACTION_TYPES.SET_ALL_RESTAURANTS,
    payload: restaurants
});

export const setFilteredRestaurants = (restaurants) => ({
    type: ACTION_TYPES.SET_FILTERED_RESTAURANTS,
    payload: restaurants
});

export const setShowSuggestions = (show) => ({
    type: ACTION_TYPES.SET_SHOW_SUGGESTIONS,
    payload: show
});

export const setSelectedSuggestionIndex = (index) => ({
    type: ACTION_TYPES.SET_SELECTED_SUGGESTION_INDEX,
    payload: index
});

export const setRestaurantNotFound = (notFound) => ({
    type: ACTION_TYPES.SET_RESTAURANT_NOT_FOUND,
    payload: notFound
});

// Wine Preferences Actions
export const setWinePreferences = (preferences) => ({
    type: ACTION_TYPES.SET_WINE_PREFERENCES,
    payload: preferences
});

export const setSelectedWinePreferences = (preferences) => ({
    type: ACTION_TYPES.SET_SELECTED_WINE_PREFERENCES,
    payload: preferences
});

export const toggleWinePreference = (preference) => ({
    type: ACTION_TYPES.TOGGLE_WINE_PREFERENCE,
    payload: preference
});

// Food Preferences Actions
export const setFoodChoice = (choice) => ({
    type: ACTION_TYPES.SET_FOOD_CHOICE,
    payload: choice
});

export const setSelectedFoodPreferences = (preferences) => ({
    type: ACTION_TYPES.SET_SELECTED_FOOD_PREFERENCES,
    payload: preferences
});

export const toggleFoodPreference = (preference) => ({
    type: ACTION_TYPES.TOGGLE_FOOD_PREFERENCE,
    payload: preference
});

// Price Range Actions
export const setPriceRange = (range) => ({
    type: ACTION_TYPES.SET_PRICE_RANGE,
    payload: range
});

export const setSelectedPriceRangeLabel = (label) => ({
    type: ACTION_TYPES.SET_SELECTED_PRICE_RANGE_LABEL,
    payload: label
});

// Other Info Actions
export const setOtherInfo = (info) => ({
    type: ACTION_TYPES.SET_OTHER_INFO,
    payload: info
});

// Messages Actions
export const setConfirmationMessage = (message) => ({
    type: ACTION_TYPES.SET_CONFIRMATION_MESSAGE,
    payload: message
});

// Recommendations Actions
export const setRecommendations = (recommendations) => ({
    type: ACTION_TYPES.SET_RECOMMENDATIONS,
    payload: recommendations
});

export const setIsLoadingRecommendations = (loading) => ({
    type: ACTION_TYPES.SET_IS_LOADING_RECOMMENDATIONS,
    payload: loading
});

export const setErrorFetchingRecommendations = (error) => ({
    type: ACTION_TYPES.SET_ERROR_FETCHING_RECOMMENDATIONS,
    payload: error
});

// Restaurant Summary Actions
export const setRestaurantSummary = (summary) => ({
    type: ACTION_TYPES.SET_RESTAURANT_SUMMARY,
    payload: summary
});

export const setIsLoadingSummaries = (loading) => ({
    type: ACTION_TYPES.SET_IS_LOADING_SUMMARIES,
    payload: loading
});

export const setErrorFetchingSummaries = (error) => ({
    type: ACTION_TYPES.SET_ERROR_FETCHING_SUMMARIES,
    payload: error
});

// Wine Details Actions
export const setSelectedWine = (wine) => ({
    type: ACTION_TYPES.SET_SELECTED_WINE,
    payload: wine
});

export const setSelectedWineInfo = (info) => ({
    type: ACTION_TYPES.SET_SELECTED_WINE_INFO,
    payload: info
});

export const setIsLoadingWineInfo = (loading) => ({
    type: ACTION_TYPES.SET_IS_LOADING_WINE_INFO,
    payload: loading
});

// Restaurant Menu Actions
export const setRestaurantMenu = (menu) => ({
    type: ACTION_TYPES.SET_RESTAURANT_MENU,
    payload: menu
});

export const setIsLoadingRestaurantMenu = (loading) => ({
    type: ACTION_TYPES.SET_IS_LOADING_RESTAURANT_MENU,
    payload: loading
});

export const setErrorFetchingRestaurantMenu = (error) => ({
    type: ACTION_TYPES.SET_ERROR_FETCHING_RESTAURANT_MENU,
    payload: error
});
